import script from "./MarkupPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkupPage.vue?vue&type=script&setup=true&lang=ts"

import "./MarkupPage.vue?vue&type=style&index=0&id=94b57254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b57254"]])

export default __exports__